import axios from "../axios";

const fetchSongs = (searchKey = "") =>
  axios.post("songs", { search: searchKey, page: 1, limit: 100 });

const fetchSongById = (id) => axios.get(`songs/song-info/${id}`);

const fetchSongsAccrodingToReaction = (type) =>
  axios.post("songs//song-reaction", { type });

const addReactioToSong = (id, type) =>
  axios.post(`songs/${id}/reactions`, { type });

const addFavouriteToSong = (id) => axios.post(`songs/${id}/favorite`);

// ! confirm this
const addSongToFavorites = (payload) =>
  axios.post(`/v1/customer/playlists/favorite/songs`, payload);

const removeSongFromFavorites = (payload) =>
  axios.delete(`/v1/customer/playlists/favorite/songs`, { data: payload });

const downloadSong = (id) => axios.get(`/media/songs/${id}`);

const startView = (id) => axios.post(`songs/${id}/add-view`);

const confirmView = (id, payload) =>
  axios.post(`songs/${id}/confirm-view`, payload);

export const songsServices = {
  fetchSongs,
  fetchSongById,
  fetchSongsAccrodingToReaction,
  addReactioToSong,
  addFavouriteToSong,
  addSongToFavorites,
  removeSongFromFavorites,
  downloadSong,
  startView,
  confirmView,
};
